import napStyles from './../napRtl.json'

const title = {
  fontSizeMobile: '26px',
  lineHeightMobile: '32.5px',
  fontWeight: '700',
  textTransform: 'none',
  fontSizeDesktop: '34px',
  lineHeightDesktop: '42.5px',
  color: napStyles.colors.PrimaryWhite
}

const cta = {
  fontWeight: '400',
  lineHeight: '17.5px',
  letterSpacing: '0.14px',
  color: napStyles.colors.PrimaryWhite
}

const paragraph = {
  fontWeight: '400',
  fontSize: '16px',
  lineHeight: '24px',
  color: napStyles.colors.PrimaryWhite
}

const loyaltyBanner = {
  title,
  cta,
  paragraph
}
export default loyaltyBanner
